module.exports = __webpack_public_path__ + "img/charging_start_tip2.67935870.png";